import React from "react";
import { useTranslation} from "react-i18next";
const CategoriesPanel = ({ categoriesPanel, location,linkPatternRender }) => {

    const { t, i18n } = useTranslation();
    
    const updateUrlPageToFirst = (queryString) => {
        const params = new URLSearchParams(queryString);
        if (params.has('page')) {
            params.set('page', '1');
        }
        return '?' + params.toString();
    }

    return (
        <>
        <div className="mob-header-offcanvas__title mob-header-offcanvas__title--category uk-position-relative">{t('shop.category')}</div>
            {categoriesPanel &&
                Object.keys(categoriesPanel).map((keyItemCategory) => {
                    const itemCategory = categoriesPanel[keyItemCategory];
                    const link = linkPatternRender?linkPatternRender.replace('%categoryFilter%',itemCategory.data.alias):`/products/ua/${itemCategory.data.alias}${updateUrlPageToFirst(location.search)}`;
                    console.log('CategoriesPanel', {linkPatternRender, categoriesPanel, link, locationSearch: updateUrlPageToFirst(location.search)});
                    return (
                        <ul key={keyItemCategory} className="uk-list category-panel-list">
                            {itemCategory.data && (
                                <li>
                                    <a
                                        href={link}
                                        className="category-panel-parent"
                                    >
                                        {itemCategory.data.nameUa}
                                    </a>
                                    <ul className="uk-list category-panel-child-list">
                                        {Object.keys(itemCategory.items).map((keyItem) => {
                                            const itm = itemCategory.items[keyItem];
                                            const linkchild = linkPatternRender?linkPatternRender.replace('%categoryFilter%',itm.alias):`/products/ua/${itm.alias}${updateUrlPageToFirst(location.search)}`
                                            return (
                                                <li key={keyItem}>
                                                    <a
                                                        href={linkchild}
                                                        className="category-panel-child"
                                                    >
                                                        {itm.nameUa}
                                                    </a>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </li>
                            )}
                        </ul>
                    );
                })}
        </>
    );
}

export default CategoriesPanel;
